import React from 'react';

import Siliconeinje from './Siliconeinje';
import Siliconapplicans from './Siliconapplicans';
import Optimizedfeatu from './Optimizedfeatu';
import Siseriesplaten from './Siseriesplaten';



const Siseriessilicon = () => {
    return (
        <div>
        <Siliconeinje />
            <Siliconapplicans />
            <Optimizedfeatu />
            <Siseriesplaten />

        </div>
    );
};
export default Siseriessilicon;
